/**
 * @flow
 * @relayHash 845986fd0a9dafadd650b4378552d032
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrokenHreflangIssuesTable_project$ref = any;
export type canonical_CanonicalCategory_BrokenHreflangIssuesTable_QueryVariables = {|
  host: string
|};
export type canonical_CanonicalCategory_BrokenHreflangIssuesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: BrokenHreflangIssuesTable_project$ref
  |}
|};
export type canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query = {|
  variables: canonical_CanonicalCategory_BrokenHreflangIssuesTable_QueryVariables,
  response: canonical_CanonicalCategory_BrokenHreflangIssuesTable_QueryResponse,
|};
*/


/*
query canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...BrokenHreflangIssuesTable_project
    id
  }
}

fragment BrokenHreflangIssuesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        brokenHreflangs(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...BrokenHreflangIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment BrokenHreflangIssuesRow_issue on BrokenHreflang {
  id
  type
  severity
  url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query",
  "id": null,
  "text": "query canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...BrokenHreflangIssuesTable_project\n    id\n  }\n}\n\nfragment BrokenHreflangIssuesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        brokenHreflangs(offset: 0, limit: 20, url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...BrokenHreflangIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment BrokenHreflangIssuesRow_issue on BrokenHreflang {\n  id\n  type\n  severity\n  url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BrokenHreflangIssuesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokenHreflangs",
                        "storageKey": "brokenHreflangs(limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "sourceUrl",
                            "value": v3,
                            "type": "TextFilters"
                          },
                          {
                            "kind": "Literal",
                            "name": "url",
                            "value": v3,
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "BrokenHreflangConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokenHreflangEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokenHreflang",
                                "plural": false,
                                "selections": [
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v4
                    ]
                  }
                ]
              }
            ]
          },
          v4
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '728b90e2d5f9ce21cf61b55bdb20db3f';
module.exports = node;
